import { useEffect, useRef } from 'react'

/**
 * PiP automático da Media Session (Chrome 120+): com o handler registrado, o navegador chama `aoDisparar`
 * quando o usuário troca de aba — e só nesse momento permite abrir o Document PiP sem clique.
 * Condições impostas pelo Chrome, fora do controle do app: HTTPS, câmera ou microfone capturando,
 * nenhum PiP já aberto e permissão do site diferente de "Bloquear".
 */
export const usePipAutomatico = (ativo: boolean, aoDisparar: () => void): void => {
  const aoDispararRef = useRef(aoDisparar)

  useEffect(() => {
    aoDispararRef.current = aoDisparar
  }, [aoDisparar])

  useEffect(() => {
    const sessao: MediaSession | undefined = navigator.mediaSession
    if (!ativo || !sessao) return

    try {
      sessao.setActionHandler('enterpictureinpicture', () => aoDispararRef.current())
    } catch {
      // Navegador sem a ação (Firefox, Safari) lança TypeError: sem PiP automático; os outros gatilhos seguem.
      return
    }

    return () => {
      sessao.setActionHandler('enterpictureinpicture', null)
    }
  }, [ativo])
}
